/**
 * ESRI is delivering Date in UTC milliseconds
 * --> convert to ISO string accepted by typescript-json-serializer
 * @param esriDate
 */
export const esriToDate = (esriDate: number): string => new Date(esriDate).toISOString();

/**
 * Convert to milliseconds (to send to feature layer)
 * @param date
 */
export const dateToEsri = (date: string): number => Date.parse(date);
